import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useMember } from "../lib/member";
import { Flame } from "lucide-react";

const MemberProtected = ({ children }) => {
  const location = useLocation();
  const { member, loading } = useMember();
  if (location.state?.member) return children;
  if (loading) return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#050505] text-[#F6F0E6]">
      <div className="icon-badge !h-12 !w-12 mb-4"><Flame className="h-6 w-6 text-[#F28C18] animate-pulse" /></div>
      <div className="overline">Connecting…</div>
    </div>
  );
  if (!member) return <Navigate to="/portal/login" replace />;
  return children;
};

export default MemberProtected;
